import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@shared/services/api/apiRequest";

export function useGetSchedulingAvailability(programId: number) {
  return useQuery({
    queryKey: ["get-scheduling-availability", programId],

    queryFn: async () => {
      return await apiRequest(
        `/api/get-availability-slots/?program_id=${programId}`,
        "GET"
      );
    },

    // Select the time_slots from the response
    select: (data) => {
      return data.time_slots;
    },

    // Prevent query from running when no programId is provided
    enabled: !!programId,

    // Disable retry to avoid repeated failures
    retry: false,
  });
}

export default useGetSchedulingAvailability;
